import React from 'react';
import { ComponentMeta, ComponentStory } from '@storybook/react';

import Box from '../Box';
import Button from '../Button';
import Popover from './Popover';

export default {
  title: 'Popover',
  component: Popover,
} as ComponentMeta<typeof Popover>;

const ControlledPopover = () => {
  const [isOpen, setIsOpen] = React.useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <Popover shown={isOpen} onClickOutside={toggle}>
      <Popover.Element>
        <Button onClick={toggle}>Element</Button>
      </Popover.Element>
      <Popover.Content>
        <Box padding="10px">Content</Box>
      </Popover.Content>
    </Popover>
  );
};

const Template: ComponentStory<typeof Popover> = () => <ControlledPopover />;

export const Basic = Template.bind({});
Basic.args = {};
